export default __webpack_public_path__ + "static/media/hive.ebfdd0be.png";